export const UPDATE = 'food/update';
export const CREATE_FOOD = 'food/createFood';
export const CREATE_FOOD_MEASURE = 'food/createFoodMeasure';
